import { RG_TYPE as t, getRgObjectsOfType as o } from "@project-rouge/rg-core";
import { getAboveLevelArea as u } from "../../metrics/scalar-metrics/index.js";
import { getAboveLevelPerimeter as l } from "../../metrics/scalar-metrics/index2.js";
import { getArea as a } from "../../metrics/scalar-metrics/index3.js";
import { getPerimeter as i } from "../../metrics/scalar-metrics/index8.js";
import { getLevelArea as s } from "../../metrics/scalar-metrics/level-metrics/index4.js";
import { getLevelPerimeter as d } from "../../metrics/scalar-metrics/level-metrics/index27.js";
import { countNorthFacingUnits as f } from "../../metrics/scalar-metrics/total-metrics/index.js";
import { getAmenitiesArea as g } from "../../metrics/scalar-metrics/total-metrics/index2.js";
import { getAmenitiesWallArea as v } from "../../metrics/scalar-metrics/total-metrics/index4.js";
import { getApartmentModuleCount as c } from "../../metrics/scalar-metrics/total-metrics/index5.js";
import { getBaseBuildDoubleDoorsCount as p } from "../../metrics/scalar-metrics/total-metrics/index6.js";
import { getBaseBuildMiscDoorsCount as C } from "../../metrics/scalar-metrics/total-metrics/index7.js";
import { getBaseBuildSingleDoorsCount as A } from "../../metrics/scalar-metrics/total-metrics/index8.js";
import { getBaseBuildWallArea as B } from "../../metrics/scalar-metrics/total-metrics/index9.js";
import { getDoubleDoorsCount as x } from "../../metrics/scalar-metrics/total-metrics/index16.js";
import { getEfficiency as F } from "../../metrics/scalar-metrics/total-metrics/index17.js";
import { getFacadeExternalCornerLength as P } from "../../metrics/scalar-metrics/total-metrics/index18.js";
import { getFacadeInternalCornerLength as h } from "../../metrics/scalar-metrics/total-metrics/index19.js";
import { getFireCoreCount as L } from "../../metrics/scalar-metrics/total-metrics/index20.js";
import { getFootprint as R } from "../../metrics/scalar-metrics/total-metrics/index21.js";
import { getGEA as W } from "../../metrics/scalar-metrics/total-metrics/index25.js";
import { getGIA as G } from "../../metrics/scalar-metrics/total-metrics/index26.js";
import { getGlazedFacadeArea as S } from "../../metrics/scalar-metrics/total-metrics/index27.js";
import { getGrossFacadeArea as D } from "../../metrics/scalar-metrics/total-metrics/index28.js";
import { getIndicativeFormFactor as N } from "../../metrics/scalar-metrics/total-metrics/index29.js";
import { getLiftCoreCount as E } from "../../metrics/scalar-metrics/total-metrics/index31.js";
import { getLiftLevels as y } from "../../metrics/scalar-metrics/total-metrics/index32.js";
import { getMaxFfl as T } from "../../metrics/scalar-metrics/total-metrics/index33.js";
import { getMaxHeight as M } from "../../metrics/scalar-metrics/total-metrics/index34.js";
import { getMiscDoorsCount as I } from "../../metrics/scalar-metrics/total-metrics/index35.js";
import { getNetFacadeArea as z } from "../../metrics/scalar-metrics/total-metrics/index36.js";
import { getNIA as H } from "../../metrics/scalar-metrics/total-metrics/index38.js";
import { getNonResidentialArea as O } from "../../metrics/scalar-metrics/total-metrics/index39.js";
import { getPodiumGlazedFacadeArea as U } from "../../metrics/scalar-metrics/total-metrics/index40.js";
import { getPodiumGrossFacadeArea as k } from "../../metrics/scalar-metrics/total-metrics/index41.js";
import { getPodiumNetFacadeArea as w } from "../../metrics/scalar-metrics/total-metrics/index44.js";
import { getProjectionArea as V } from "../../metrics/scalar-metrics/total-metrics/index45.js";
import { getResidentialEfficiency as Y } from "../../metrics/scalar-metrics/total-metrics/index46.js";
import { getResidentialGlazedFacadeArea as _ } from "../../metrics/scalar-metrics/total-metrics/index47.js";
import { getResidentialGrossFacadeArea as q } from "../../metrics/scalar-metrics/total-metrics/index48.js";
import { getResidentialLevelCount as J } from "../../metrics/scalar-metrics/total-metrics/index49.js";
import { getResidentialNetFacadeArea as K } from "../../metrics/scalar-metrics/total-metrics/index50.js";
import { getRoofGrossFacadeArea as Q } from "../../metrics/scalar-metrics/total-metrics/index51.js";
import { getRoofNetFacadeArea as X } from "../../metrics/scalar-metrics/total-metrics/index52.js";
import { getServicesArea as Z } from "../../metrics/scalar-metrics/total-metrics/index53.js";
import { getServicesWallArea as $ } from "../../metrics/scalar-metrics/total-metrics/index55.js";
import { getSingleDoorsCount as b } from "../../metrics/scalar-metrics/total-metrics/index56.js";
import { getUnitToLiftCoreRatio as j } from "../../metrics/scalar-metrics/total-metrics/index58.js";
import { getVerticalWallArea as m } from "../../metrics/scalar-metrics/total-metrics/index59.js";
import { getRgObjectsAtLevel as ee } from "../../utils/rg-util/index3.js";
import { buildingMetrics as r } from "./index.js";
import { getCountOfType as n } from "../../metrics/counting/index.js";
import { getAmenitiesPerimeter as re } from "../../metrics/scalar-metrics/total-metrics/index3.js";
import { getClearInternalHeight as te } from "../../metrics/scalar-metrics/total-metrics/index10.js";
import { getCommercialArea as ae } from "../../metrics/scalar-metrics/total-metrics/index11.js";
import { getCommercialPerimeter as ie } from "../../metrics/scalar-metrics/total-metrics/index12.js";
import { getCommercialWallArea as me } from "../../metrics/scalar-metrics/total-metrics/index13.js";
import { getPodiumHeightSum as ne } from "../../metrics/scalar-metrics/total-metrics/index42.js";
import { getServicesPerimeter as oe } from "../../metrics/scalar-metrics/total-metrics/index54.js";
import { getSumExternalWallPerimeter as ue } from "../../metrics/scalar-metrics/total-metrics/index57.js";
import { getWallToFloorRatio as le } from "../../metrics/scalar-metrics/total-metrics/index60.js";
import { getFoundationConcreteWeight as se } from "../../metrics/scalar-metrics/total-metrics/index23.js";
import { getFoundationSteelWeight as de } from "../../metrics/scalar-metrics/total-metrics/index24.js";
import { getPodiumLevelCount as fe } from "../../metrics/scalar-metrics/total-metrics/index43.js";
function Lr(e) {
  return [
    { name: r.gea, value: W(e), unit: "m\xB2" },
    { name: r.gia, value: G(e), unit: "m\xB2" },
    { name: r.nia, value: H(e), unit: "m\xB2" },
    { name: r.buildingCount, value: n(e, t.Building), unit: "unitless" },
    { name: r.maxResidentialLevelCount, value: J(e), unit: "unitless" },
    { name: r.footprint, value: R(e), unit: "m\xB2" },
    { name: r.projection, value: V(e), unit: "m\xB2" },
    { name: r.nonResidentialArea, value: O(e), unit: "m\xB2" },
    { name: r.roofArea, value: a(e, [t.Roof]), unit: "m\xB2" },
    { name: r.roofPerimeter, value: i(e, [t.Roof]), unit: "m" },
    { name: r.facadeGrossArea, value: D(e), unit: "m\xB2" },
    { name: r.facadeNetArea, value: z(e), unit: "m\xB2" },
    { name: r.facadeGlazedArea, value: S(e), unit: "m\xB2" },
    { name: r.podiumFacadeArea, value: k(e), unit: "m\xB2" },
    { name: r.podiumNetFacadeArea, value: w(e), unit: "m\xB2" },
    { name: r.podiumGlazedFacadeArea, value: U(e), unit: "m\xB2" },
    { name: r.residentialFacadeArea, value: q(e), unit: "m\xB2" },
    { name: r.residentialNetFacadeArea, value: K(e), unit: "m\xB2" },
    { name: r.residentialGlazedFacadeArea, value: _(e), unit: "m\xB2" },
    { name: r.roofGrossFacadeArea, value: Q(e), unit: "m\xB2" },
    { name: r.roofNetFacadeArea, value: X(e), unit: "m\xB2" },
    { name: r.facadeInternalCornersLength, value: h(e), unit: "m" },
    { name: r.facadeExternalCornersLength, value: P(e), unit: "m" },
    { name: r.entranceCount, value: n(e, t.Entrance), unit: "unitless" },
    { name: r.flightsOfStairs, value: o(e, t.Core).length, unit: "unitless" },
    { name: r.liftLevels, value: y(e), unit: "unitless" },
    { name: r.coreCount, value: ee(e, t.Core, 0).length, unit: "unitless" },
    { name: r.liftCoreCount, value: E(e, 0), unit: "unitless" },
    { name: r.fireCoreCount, value: L(e, 0), unit: "unitless" },
    { name: r.doubleDoorCount, value: x(e), unit: "unitless" },
    { name: r.singleDoorCount, value: b(e), unit: "unitless" },
    { name: r.miscDoorCount, value: I(e), unit: "unitless" },
    { name: r.baseBuildDoubleDoorCount, value: p(e), unit: "unitless" },
    { name: r.baseBuildSingleDoorCount, value: A(e), unit: "unitless" },
    { name: r.baseBuildMiscDoorCount, value: C(e), unit: "unitless" },
    { name: r.moduleCount, value: c(e), unit: "unitless" },
    { name: r.efficiency, value: F(e), unit: "unitless" },
    { name: r.residentialEfficiency, value: Y(e), unit: "unitless" },
    { name: r.ffl, value: T(e), unit: "m" },
    { name: r.maxHeight, value: M(e), unit: "m" },
    { name: r.wallToFloorRatio, value: le(e), unit: "unitless" },
    { name: r.emptySpaceArea, value: a(e, [t.EmptySpace]), unit: "m\xB2" },
    { name: r.commercialArea, value: ae(e), unit: "m\xB2" },
    { name: r.commercialPerimeter, value: ie(e), unit: "m" },
    { name: r.commercialSpacesWallArea, value: me(e), unit: "m\xB2" },
    { name: r.amenitiesArea, value: g(e), unit: "m\xB2" },
    { name: r.amenitiesPerimeter, value: re(e), unit: "m" },
    { name: r.amenityTechSpacesWallArea, value: v(e), unit: "m\xB2" },
    { name: r.servicesArea, value: Z(e), unit: "m\xB2" },
    { name: r.servicesPerimeter, value: oe(e), unit: "m" },
    { name: r.serviceTechSpacesWallArea, value: $(e), unit: "m\xB2" },
    { name: r.indicativeFormFactor, value: N(e), unit: "unitless" },
    { name: r.coreArea, value: a(e, [t.Core]), unit: "m\xB2" },
    { name: r.corePerimeter, value: i(e, [t.Core]), unit: "m" },
    { name: r.coreWallArea, value: m(e, [t.Core]), unit: "m\xB2" },
    { name: r.corridorArea, value: a(e, [t.Corridor]), unit: "m\xB2" },
    { name: r.corridorPerimeter, value: i(e, [t.Corridor]), unit: "m" },
    { name: r.corridorWallArea, value: m(e, [t.Corridor]), unit: "m\xB2" },
    { name: r.coreAndCorridorArea, value: a(e, [t.Core, t.Corridor]), unit: "m\xB2" },
    { name: r.coreAndCorridorPerimeter, value: i(e, [t.Core, t.Corridor]), unit: "m" },
    { name: r.coreAndCorridorWallArea, value: m(e, [t.Core, t.Corridor]), unit: "m\xB2" },
    { name: r.groundCoreAndCorridorArea, value: s(e, 0, [t.Core, t.Corridor]), unit: "m\xB2" },
    { name: r.groundCoreAndCorridorPerimeter, value: d(e, 0, [t.Core, t.Corridor]), unit: "m" },
    { name: r.aboveGroundCoreAndCorridorArea, value: u(e, 0, [t.Core, t.Corridor]), unit: "m\xB2" },
    { name: r.aboveGroundCoreAndCorridorPerimeter, value: l(e, 0, [t.Core, t.Corridor]), unit: "m" },
    { name: r.baseBuildWallArea, value: B(e), unit: "m\xB2" },
    { name: r.countNorthFacingUnits, value: f(e), unit: "unitless" },
    { name: r.unitToLiftCoreRatio, value: j(e), unit: "unitless" },
    { name: r.podiumHeight, value: ne(e), unit: "m" },
    { name: r.clearInternalHeight, value: te(e), unit: "m" },
    { name: r.sumExternalWallPerimeter, value: ue(e), unit: "m" },
    { name: r.foundationConcreteWeight, value: se(e), unit: "kg" },
    { name: r.foundationSteelWeight, value: de(e), unit: "kg" },
    { name: r.podiumLevelCount, value: fe(e), unit: "unitless" }
  ];
}
export {
  Lr as getStoryMetricsTotals
};
//# sourceMappingURL=index6.js.map
